import React from 'react';

const LimitSelector = ({ currentLimit, onLimitChange, totalContacts }) => {
  const limitOptions = [10, 25, 50, 100];

  return (
    <div className="flex items-center space-x-2 text-sm text-gray-800">
      <span>Show:</span>
      <select
        value={currentLimit}
        onChange={(e) => onLimitChange(parseInt(e.target.value))}
        className="border border-gray-300 rounded-md px-2 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-[#3985b6] focus:border-[#3985b6]"
      >
        {limitOptions.map(option => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
      <span>per page</span>
      {totalContacts && (
        <span className="text-gray-500">
          ({totalContacts} total contacts)
        </span>
      )}
    </div>
  );
};

export default LimitSelector;